import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/react-query';

import { Conversation } from '../types';

import { getUnreadMessagesCountQueryOptions } from './getUnreadMessagesCount';

export const markAsRead = ({
  conversationId,
}: {
  conversationId: string;
}): Promise<Conversation> => {
  return api.put(`/users/conversations/${conversationId}/mark-as-read`, null, {
    withCredentials: true,
  });
};

type UseMarkAsReadOptions = {
  mutationConfig?: MutationConfig<typeof markAsRead>;
};

export const useMarkAsRead = ({
  mutationConfig,
}: UseMarkAsReadOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      queryClient.invalidateQueries({
        queryKey: ['conversations', data.id],
      });
      queryClient.invalidateQueries({
        queryKey: getUnreadMessagesCountQueryOptions().queryKey,
      });
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: markAsRead,
  });
};
